import { drawerAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  drawerAnatomy.keys,
);

const baseStyle = definePartsStyle({
  overlay: {
    bg: 'overlay.alpha',
  },
  dialog: {
    bg: 'bg.elevated',
    color: 'text.primary',
    borderWidth: '1px',
    borderColor: 'border.muted',
    boxShadow: 'elevation.2',
    borderRadius: 'lg',
  },
  closeButton: {
    color: 'text.muted',
    _hover: {
      color: 'text.primary',
    },
    _focusVisible: {
      boxShadow: '0 0 0 2px var(--chakra-colors-accent-default)',
    },
  },
});

export const Drawer = defineMultiStyleConfig({
  baseStyle,
});
